import axios from "axios";
export default {
  data() {
    return {
      apiUrl: "",
    };
  },
  beforeMount() {
    this.apiUrl = this.mfConfig.api;
    this.checkStatus();
  },
  methods: {
    //Check session status
    checkStatus() {
      axios
        .head(this.apiUrl + "/" + this.realm + "/status", {
          withCredentials: true,
        })
        .then((response) => {
          console.log("HEAD STATUS: ", response);
          document.dispatchEvent(new CustomEvent("mf-auth-mounted"));
          if (response.status === 200) {
            sessionStorage.setItem("userAuthenticated", "true");
          }
        })
        .catch((error) => {
          let authenticated = sessionStorage.getItem("userAuthenticated");
          if (authenticated == null || authenticated != "true") {
            this.setError(error, true, "error-login-callback");
          } else {
            this.setError(error, false);
          }
        });
    },
    //Redirect to user login page
    login(tenantId) {
      window.location.assign(this.apiUrl + "/" + tenantId + "/auth/login");
    },
    //Logout from user session
    logout() {
      sessionStorage.removeItem("userAuthenticated");
      window.location = this.apiUrl + "/" + this.realm + "/auth/logout";
    },
  },
};
